export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-[72px] pb-16 md:pb-20">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20interior%20with%20warm%20red%20velvet%20curtains%2C%20soft%20ambient%20golden%20stage%20lighting%2C%20empty%20luxurious%20auditorium%20with%20plush%20seats%2C%20atmospheric%20and%20dramatic%20mood%2C%20rich%20textures%2C%20cinematic%20photography%20style%20with%20deep%20shadows%20and%20warm%20highlights%2C%20elegant%20and%20immersive&width=1800&height=1200&seq=hero-bg-movie-01&orientation=landscape"
          alt="影院氛围背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-[1400px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-400 text-xs md:text-sm font-medium tracking-wide mb-4 md:mb-6">
              每日更新 · 海量片源
            </span>

            <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-3 md:mb-4">
              91电影视频
              <br className="sm:hidden" />
              <span className="text-accent-400">免费高清影视</span>
              <br />
              在线观看平台
            </h1>

            <p className="text-sm md:text-base text-background-200/80 mb-3 md:mb-4 font-heading italic tracking-wide">
              无需注册 · 即点即播 · 高清不缓冲
            </p>

            <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
              <p className="text-sm md:text-base text-background-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0">
                91电影视频汇聚全网最新最全的影视资源，涵盖动作片、喜剧片、爱情片、科幻片、恐怖片、动画片、纪录片等多种类型。
                平台每日实时更新热播剧集和院线新片，全部免费在线观看，高清画质流畅不缓冲。
              </p>
              <p className="text-sm md:text-base text-background-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0">
                当前热播专题：《暗夜追踪》《星河战纪》《都市寓言》等重磅新片持续上架，追剧党不可错过的免费看片首选。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-6 md:mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">20000+</div>
                <div className="text-xs md:text-sm text-background-300/70 mt-1">海量片源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-xs md:text-sm text-background-300/70 mt-1">新鲜剧集</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">1080P</div>
                <div className="text-xs md:text-sm text-background-300/70 mt-1">高清画质</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg font-semibold text-sm transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                开始浏览
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 border border-background-300/40 hover:border-background-200/60 text-background-50 hover:text-background-50 rounded-lg font-medium text-sm transition-all whitespace-nowrap cursor-pointer text-center"
              >
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20projector%20with%20warm%20golden%20light%20rays%20streaming%20through%2C%20dramatic%20theater%20screen%20glowing%20with%20vivid%20colors%2C%20classic%20movie%20posters%20on%20dark%20brick%20wall%2C%20vintage%20cinema%20aesthetic%20with%20modern%20elements%2C%20rich%20contrast%20lighting%2C%20atmospheric%20and%20nostalgic%20mood&width=900&height=675&seq=hero-main-visual-01&orientation=landscape"
                alt="91电影视频 - 影视在线观看平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <span className="px-3 py-1.5 bg-primary-500/90 text-background-50 text-xs font-semibold rounded-md whitespace-nowrap">热播中</span>
                <span className="text-background-50 text-sm font-medium whitespace-nowrap">每日万人在线观看</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}